module.exports = __webpack_public_path__ + "static/media/S3N11-4.7b2a8cd3.svg";